import IconComponent from "icons/IconComponent";

import CloseCircle from "./close-circle.svg";

export default (CloseCircle as any) as IconComponent;
